import SiteEnum from '@models/enums/SiteEnum';
import SharedBreadcrumb, {
  PageBreadcrumbProps,
} from '@molecules/PageBreadcrumb/PageBreadcrumb';

const PageBreadcrumb = (props: PageBreadcrumbProps) => (
  <SharedBreadcrumb {...props} site={SiteEnum.Deco} />
);

export default PageBreadcrumb;
